import React, { useEffect, useState } from 'react';

const MatrixRain = ({ isActive }) => {
  const [columns, setColumns] = useState([]);
  
  const chars = 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ@#$%&*';

  useEffect(() => {
    if (!isActive) {
      setColumns([]);
      return;
    }

    // Create columns
    const numColumns = Math.floor(window.innerWidth / 20);
    const newColumns = Array.from({ length: numColumns }, (_, i) => ({
      id: i,
      left: i * 20,
      delay: Math.random() * 2,
      duration: 2 + Math.random() * 3,
      chars: Array.from({ length: 25 }, () => chars[Math.floor(Math.random() * chars.length)])
    }));
    setColumns(newColumns);
  }, [isActive]);

  if (!isActive) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 99999,
      pointerEvents: 'none',
      overflow: 'hidden',
      background: 'rgba(0, 0, 0, 0.65)'
    }}>
      {columns.map((col) => (
        <div
          key={col.id}
          style={{
            position: 'absolute',
            left: `${col.left}px`,
            top: '-500px',
            color: '#b06bff',
            fontFamily: 'monospace',
            fontSize: '18px',
            textShadow: '0 0 10px #b06bff, 0 0 20px #b06bff',
            animation: `matrixFall ${col.duration}s linear infinite`,
            animationDelay: `${col.delay}s`,
            whiteSpace: 'nowrap',
            writingMode: 'vertical-rl',
            textOrientation: 'upright',
            letterSpacing: '5px'
          }}
        >
          {col.chars.map((char, i) => (
            <span 
              key={i} 
              style={{ 
                opacity: i === 0 ? 1 : 0.3 + (0.7 * (1 - i / col.chars.length)),
                color: i === 0 ? '#FFFFFF' : '#b06bff'
              }}
            >
              {char}
            </span>
          ))}
        </div>
      ))}
      
      <div style={{
        position: 'absolute',
        bottom: '30px',
        left: '50%',
        transform: 'translateX(-50%)',
        color: '#b06bff',
        fontFamily: 'Fira Code, monospace',
        fontSize: '18px',
        textShadow: '0 0 10px #b06bff, 0 0 20px #b06bff',
        animation: 'matrixPulse 1s ease-in-out infinite',
        background: 'rgba(0, 0, 0, 0.8)',
        padding: '10px 20px',
        borderRadius: '4px',
        border: '1px solid rgba(176, 107, 255, 0.5)',
        zIndex: 10
      }}>
        🔴 MATRIX MODE ACTIVE
      </div>

      <style>{`
        @keyframes matrixFall {
          0% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(calc(100vh + 600px));
          }
        }
        @keyframes matrixPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.7; }
        }
      `}</style>
    </div>
  );
};

export default MatrixRain;
